import { withStyles } from '@material-ui/core/styles';
import MuiLinearProgress from '@material-ui/core/LinearProgress';
const AppLinearProgress = withStyles(() => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 999,
    },
}))(MuiLinearProgress);
export default AppLinearProgress;
